module.exports = __webpack_public_path__ + "img/icon-store-profile.3f5b6773.svg";